import { VehicleStatus } from "../../../Enum/vehcile-status.enum";
import { VehicleStatusenum } from "../masters/vehicles/vehicle.enum";

export class vehicleReportReq{
    requestDate?:any;
    raisedDate?:any;
    status?:VehicleStatus;
    department:string;
    departmentId:number;
    

}